import { create } from 'zustand';

interface UIStore {
  jobFilterStatus: 'all' | 'active' | 'expired' | 'applied' | 'rejected';
  searchQuery: string;

  setJobFilterStatus: (status: 'all' | 'active' | 'expired' | 'applied' | 'rejected') => void;
  setSearchQuery: (query: string) => void;
}

export const useUIStore = create<UIStore>((set) => ({
  jobFilterStatus: 'all',
  searchQuery: '',

  setJobFilterStatus: (status) => set({ jobFilterStatus: status }),
  setSearchQuery: (query) => set({ searchQuery: query }),
}));
